import { render, staticRenderFns } from "./NewsEvent.vue?vue&type=template&id=7b08b34e&"
import script from "./NewsEvent.vue?vue&type=script&lang=js&"
export * from "./NewsEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports